<app-layout-page>
  <app-layout-header></app-layout-header>

  <app-layout-content>
    <label class="downloadMedia">
      <input type="checkbox" [checked]="downloadMedia" (change)="downloadMedia = !downloadMedia">
      Download video and audio files in face and voice checks
    </label>
    <label class="downloadFrames">
      <input type="checkbox" [checked]="downloadFrames" (change)="downloadFrames = !downloadFrames">
      Download individual JPEGs generated by AVI Recorder (will be several per video)
    </label>
    <label class="showFaceUi">
      <input type="checkbox" [checked]="enableFaceTrackerUi" (change)="enableFaceTrackerUi = !enableFaceTrackerUi">
      Show the face detection UI during face check
    </label>
  </app-layout-content>
</app-layout-page>
